
(function() {
  function applyDiscountFromUrl() {
    const code = new URLSearchParams(window.location.search).get('discount');
    if (!code) return;

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    // Register the code with Shopify's native discount endpoint, which sets the
    // discount cookie so the code auto-applies at checkout. Then force a cart
    // update so any AJAX/mini-cart reading cart.js re-reads the current state.
    // The cart update is intentionally a no-op (empty updates) so it triggers a
    // recalculation without overwriting existing cart attributes set elsewhere.
    fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function() {
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: {} })
        });
      })
      .catch(function() {});
  }

  document.addEventListener('DOMContentLoaded', applyDiscountFromUrl);
})();
